import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {ArenaLeague, BattleLog, LeagueDto} from "@/store/arena/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import ResourceUtils from "@/utils/resource-utils";
import ArenaUtils from "@/utils/arena-utils";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import {keys} from "lodash";
import {EventRewardDto, EventRewardType} from "@/store/task/types";
import {ChestType} from "@/store/player/types";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import TaskUtils from "@/utils/task-utils";

export class EventRewardPanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, rewards: EventRewardDto[]){
        super(scene, canvas, Tr('nagrada.za.sobitie').toUpperCase());

        let y = -80;
        let x = 0;

        let taskImg = SpriteUtils.addImage(scene, x, y, Keys.ATLAS_BANK, 'gems-2', 1);
        let splashImg = SpriteUtils.addImage(scene, x, y, Keys.WHEEL_SPLASH, undefined, 1, 0.8);
        splashImg.alpha = 0.5;

        let rewardInfo = TextUtils.addTextAdvanced(scene, Tr('nagrada.za.sobitie.nachislena'),
            x, y + 90, "#ffffff", 15, 'normal',  500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        rewardInfo.setOrigin(0.5)

        let text = "";
        rewards.forEach(r => {
            text += this.getRewardDesc(r) + ", ";
        })
        text = text.slice(0, -2);

        let rewardText = new BBCodeText(scene, x, y + 140, text, {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            wrap: {
                mode: 1,
                width: 560
            }
        }).setScale(CU.S, CU.S);
        rewardText.setOrigin(0.5);

        this.addButton(Tr('horosho'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, ()=>{}, false);
        this.add([splashImg, taskImg, rewardText, rewardInfo]);
    }

    protected addButton(text: string, buttonBackground: string, buttonAtlas: string | undefined, buttonIcon: string, callback?: () => unknown, disableAutoClose?:  boolean): void {
        let button = this.addCustomButton(this.getCloseButtonX(), this.getCloseButtonY(), text, buttonBackground, buttonAtlas, buttonIcon, callback, disableAutoClose);
        button.setScale(0.8)
        button.y+=25;
    }

    private getRewardDesc(reward: EventRewardDto ){
        switch (reward.type) {
            case EventRewardType.GEMS:
                return '[color=#1effd5]' + reward.value + " " + Tr('izumrudov') + '[/color]';
            case EventRewardType.CHEST:
                for(let ct in ChestType) {
                    if(ct.toString() == reward.optionalId) {
                        switch (ct) {
                            case ChestType.AZURE:
                                return '[color=#ffcd17]' + Tr('az.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.GOLD:
                                return '[color=#ffcd17]' + Tr('gld.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.LAVA:
                                return '[color=#ffcd17]' + Tr('lv.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.AMBER:
                                return '[color=#ffcd17]' + Tr('amb.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.JADE:
                                return '[color=#ffcd17]' + Tr('jd.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value + '[/color]' : '');
                            case ChestType.SILVER:
                        }
                        return '[color=#ffffff]' + Tr('slv.chst') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
                    }
                }
            case EventRewardType.HERO1:
                return '[color=#d146ff]' + Tr('unique.hero.1') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
            case EventRewardType.HERO2:
                return '[color=#d146ff]' + Tr('unique.hero.2') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
            case EventRewardType.HERO3:
                return '[color=#d146ff]' + Tr('unique.hero.3') + '[/color]' + (reward.value > 1 ? ' [color=#27ff0d]x' + reward.value +'[/color]' : '');
        }
    }
}
